import { ReactNode } from "react";

type OfferSectionProps = {
  label: string;
  children: ReactNode;
  show?: boolean;
  className?: string
};

export default function OfferSection({ label, children, show = true, className }: OfferSectionProps) {
  if (!show) return null;

  return (
    <div className={`p-4 bg-gray-50 rounded-xl ${className}`}>
      <p className="text-sm text-gray-500">{label}</p>
      {children}
    </div>
  );
}
